const mobileNavigation = () => ({
	isOpen: false,
	mediaQueryList: null as MediaQueryList | null,

	handleBreakpoint(e: MediaQueryList | MediaQueryListEvent): void {
		if (e.matches) {
			this.isOpen = true;
		} else {
			this.isOpen = false;
		}
	},
	open(): void {
		this.isOpen = true;
	},
	close(): void {
		this.isOpen = false;
	},
	toggle() {
		this.isOpen = !this.isOpen;
	},
	init(): void {
		this.mediaQueryList = window.matchMedia("(min-width: 64rem)");
		this.handleBreakpoint(this.mediaQueryList);

		this.mediaQueryList.addEventListener("change", (e) =>
			this.handleBreakpoint(e),
		);
	},
});
export default mobileNavigation;
